// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__1giR5","clickable":"WidgetWrapper_clickable__33lHl"};